export default __webpack_public_path__ + "static/ampm-7a7ac7a1d7d5e5759cedf6505f5d7f38.mp4";